import {useState} from 'react';
import {
  FetchedBuySideOrganization,
  FetchedOrganization,
  FetchedSavedExports,
  useSavedExportLazyQuery,
} from '@analytics/graphql-api';
import {ReportsTableButton} from '../shared';

type Props = {
  disabled?: boolean;
  organization: FetchedOrganization | FetchedBuySideOrganization;
  savedExport: FetchedSavedExports[number];
};

export function ReportDownloadButton({
  disabled,
  organization,
  savedExport,
}: Props) {
  const [error, setError] = useState(false);
  const [fetchDownloadUrl, {loading}] = useSavedExportLazyQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: savedExport?.id,
      organizationId: organization.id,
    },
    onCompleted: (data) => {
      const downloadUrl =
        data?.me?.organization?.exports?.savedExport?.lastExportInstance
          ?.downloadUrl;

      if (downloadUrl) {
        const newTab = window.open(downloadUrl, '_blank', 'noreferrer');
        if (newTab) newTab.opener = null;
      } else setError(true);
    },
    onError: (e) => {
      console.warn(e.message);
      setError(true);
    },
  });

  return (
    <ReportsTableButton
      error={error}
      loading={loading}
      buttonIconProps={{
        disabled,
        icon: 'reports',
        onClick: () => {
          if (error) setError(false);
          fetchDownloadUrl();
        },
      }}
      tooltipProps={{
        description: 'Download report',
      }}
    />
  );
}
